module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "body"
  }, [(!_vm.locales.length) ? _c('div', [_vm._v("You have no locales configured yet.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.locales), function(locale) {
    return _c('div', [_c('h4', {
      staticClass: "group__headline"
    }, [_vm._v(_vm._s(locale.name))]), _vm._v(" "), _c('div', [_vm._l((_vm.options), function(field) {
      return _c('el-form-item', {
        key: field.value,
        attrs: {
          "label": field.label
        }
      }, [_c("el-input", {
        tag: "div",
        attrs: {
          "type": "textarea"
        },
        model: {
          value: (_vm.translations[locale.id][field.value]),
          callback: function($$v) {
            _vm.$set(_vm.translations[locale.id], field.value, $$v)
          },
          expression: "translations[locale.id][field.value]"
        }
      }), _vm._v("\n                " + _vm._s(_vm.model[field.value]) + "\n            ")], 1)
    }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmit(locale.id)
        }
      }
    }, [_vm._v("Save this translations")])], 1)], 2)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1434e7d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Translations.vue
// module id = 521
// module chunks = 1